import React from "react";
import Banner from "../components/Banner";
import Contact from "../components/Contact";
import Header from "../components/Header";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import Testimonials from "../components/Testimonials";

const Home = () => {
  return (
    <div>
      <Header />
      <Banner />
      <Skills />
      <Projects />
      <Testimonials />
      <Contact />
    </div>
  );
};

export default Home;
